import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { FollowType } from '../../utils/backend-api/follow';
import TopicFollowAndTagModal from '../Topic/TopicFollowAndTagModal';
import FollowButton from '../shared/FollowButton';
import { SearchPageProps } from './index';
import styles from './styles.module.scss';

interface SearchHeaderProps
  extends Omit<
    SearchPageProps,
    'articleContent' | 'numArticleResults' | 'page' | 'query' | 'scope' | 'topEntities'
  > {
  isSignedIn: boolean;
  numResults: number;
}

const SearchHeader = ({
  customBlurb,
  followCount,
  followers,
  followStatus,
  isSignedIn,
  matchingEntity,
  numResults,
  title,
  topicOrAuthorLink,
  topRelatedEntities,
}: SearchHeaderProps) => {
  const topicOrAuthorLinkText =
    topicOrAuthorLink && topicOrAuthorLink.split('/')[1] === 'u'
      ? 'Author Profile'
      : 'The Information Topic';

  return (
    <div className={clsx(styles.titleSection, 'row')}>
      <div className="col-md-8 col-xs-12">
        <div className={styles.searchPageHeader}>
          <div className={styles.searchPageTitle}>
            {title}
            {matchingEntity && (
              <FollowButton
                followStatus={followStatus}
                followeeId={matchingEntity.id}
                followType={FollowType.Entity}
                showSubscribeModal={!isSignedIn}
                name={matchingEntity.name}
              />
            )}
          </div>
          {topicOrAuthorLink && (
            <div className={styles.topicOrAuthorLink}>
              {topicOrAuthorLinkText}: <a href={topicOrAuthorLink}>{title}</a>
            </div>
          )}
          {numResults > 0 && (
            <div className={styles.subtitle}>
              {numResults}{' '}
              <span className={styles.subtitleText}>Result{numResults > 1 && 's'}</span>
            </div>
          )}
          {customBlurb && <div className={styles.customBlurb}>{ReactHtmlParser(customBlurb)}</div>}
        </div>
      </div>
      {matchingEntity && (followCount > 0 || topRelatedEntities?.length > 0) && (
        <div className="col-md-4 col-xs-12">
          <TopicFollowAndTagModal
            totalFollowers={followCount}
            followers={followers}
            relatedTopics={topRelatedEntities || []}
          />
        </div>
      )}
    </div>
  );
};

export default SearchHeader;
